import React from 'react'

import SignUp from './sign-up/SignUpContainer'
import Login from './log-in/LoginContainer'

export default () => (
  <>
    <Login />
    <SignUp />
  </>
)
